import Vue from 'vue'
import Router from 'vue-router'
import MiddleHome from "@/components/middle/MiddleHome"
import Home from '@/components/Home'
import Page404 from '@/components/404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: MiddleHome,
    },
    { //兼容旧主页入口
      path: '/home',
      redirect: '/'
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404,
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js